import React, {useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {PasswordForm} from '../components/PasswordForm';
import {useSignUpMutation} from '../../../graphql/graphql.types';
import {PasswordFormValues} from '../components/types';
import {useQueryParams} from '../../../router/useQueryParams';
import {AuthMessage} from '../../../auth/AuthMessage';
import {jwtTokenPayload} from '../../../auth/jwtTokenPayload';
import {Paths} from '../../../router/paths';
import {useSnackbar} from '../../../components/snackbar/useSnackbar';
import {lang} from '../../../lang/lang';

export const CreatePasswordPage = () => {
    const {errorNotification, successNotification} = useSnackbar();
    const history = useHistory();
    const token = useQueryParams().get('token');
    const email = useMemo(() => jwtTokenPayload<{email: string}>(token || '')?.email, [token]);
    const [signUp] = useSignUpMutation();
    const handleSubmit = useCallback(async (values: PasswordFormValues) => {
        if (!token) {
            return;
        }

        try {
            await signUp({
                variables: {
                    token,
                    password: values.password,
                },
            });

            successNotification(lang.auth.password.notification.created);
            history.push(Paths.SIGN_IN);
        } catch {
            errorNotification(lang.auth.password.notification.creationFailed);
        }
    }, [errorNotification, history, signUp, successNotification, token]);

    if (!token || !email) {
        return (
            <AuthMessage title={lang.auth.password.tokenFailure.createTitle}>
                {lang.auth.password.tokenFailure.description}
            </AuthMessage>
        );
    }

    return (
        <PasswordForm email={email} onSubmit={handleSubmit} title={lang.auth.password.formTitle} />
    );
};
